import React from "react";
import { LuPencil, LuEye, LuTrash, LuLoader } from "react-icons/lu";
import { Switch } from "../Switch";

type IItemAction = {
  delete_loading?: boolean;
  show_view?: boolean;
  show_edit?: boolean;
  show_delete?: boolean;
  show_toggle?: boolean;
  toggle_checked?: boolean;
  toggle_loading?: boolean;
  toggle_label?: string;
  onToggle?: (checked: boolean) => void;
  onView?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
};

const ItemAction: React.FC<IItemAction> = ({
  delete_loading,
  show_delete = true,
  show_edit = true,
  show_view = true,
  show_toggle = false,
  toggle_checked = false,
  toggle_loading = false,
  toggle_label,
  onToggle,
  onDelete,
  onEdit,
  onView,
}) => {
  return (
    <div className="flex items-center gap-3">
      {show_view && (
        <button
          onClick={onView}
          className="bg-gray-100 hover:bg-gray-300 text-gray-800 p-2 rounded-md"
        >
          <LuEye size={18} />
        </button>
      )}
      {show_edit && (
        <button
          onClick={onEdit}
          className="bg-blue-50 hover:bg-blue-300 text-blue-800 p-2 rounded-md"
        >
          <LuPencil size={18} />
        </button>
      )}
      {show_delete && (
        <button
          onClick={onDelete}
          className="bg-red-50 hover:bg-red-300 text-red-800 p-2 rounded-md"
        >
          {delete_loading ? (
            <div>
              <LuLoader size={18} className="animate-spin" />
            </div>
          ) : (
            <LuTrash size={18} />
          )}
        </button>
      )}
      {show_toggle && (
        <div className="flex items-center gap-2">
          {toggle_label && (
            <span className="text-xs text-gray-600">{toggle_label}</span>
          )}
          {toggle_loading ? (
            <LuLoader
              size={18}
              className="animate-spin text-gray-500"
              aria-label="Updating status"
            />
          ) : (
            <Switch
              checked={toggle_checked}
              onCheckedChange={onToggle}
              aria-label={`Set status ${toggle_checked ? "active" : "inactive"}`}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ItemAction;
